import { render } from "./PaginationButtons.vue?vue&type=template&id=637b2904&scoped=true"
import script from "./PaginationButtons.vue?vue&type=script&lang=js"
export * from "./PaginationButtons.vue?vue&type=script&lang=js"

import "./PaginationButtons.vue?vue&type=style&index=0&id=637b2904&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637b2904"]])

export default __exports__